import React, { useContext, useRef } from "react"

// context
import {CatalogueContext, SearchContext} from "../../../../context"

// components
import {ActivityLink, ActivityPackageLink, Button} from "../../../controls"

// styling
import "./List.scss"

// the component
function List() {
  // references
  const refListTop = useRef();

  // get the context
  let catalogue = useContext(CatalogueContext)
  let search = useContext(SearchContext)

  // context not yet ready? render nothing
  if(!catalogue.isReady) {
    // TODO render some loading animation
    return null
  }

  // get the items from context and map them, count and set texts
  let items = [];
  let countText = null;
  let resetButton = null;
  if(search.subcatalogue === "singles") {
    // map items
    items = (search.result || [])
      .filter((a, index) => {
        // TODO this filter is just for testing purposes
        return true // return index < 10
      })
      .map(a => {
        return <ActivityLink key={a._id} activity={a} displayAsPlaceholder={true} />
      });
    // count
    if(search.result.length === 0) {
      countText = "Für diesen Filter gibt es leider keine passenden Erlebnisse ..."
      resetButton = <Button onClick={() => search.reset()} kind="ok">Filter löschen</Button>
    }
    else if(search.result.length !== catalogue.activities.standard.length) {
      countText = `${search.result.length} von ${catalogue.activities.standard.length} Erlebnissen`;
      resetButton = <Button onClick={() => search.reset()} kind="ok">Alle Erlebnisse anzeigen</Button>; 
    }
  }
  else {
    // map items
    items = (search.resultPackages || []).map(ap => {
      return <ActivityPackageLink key={ap._id} activityPackage={ap} />
    })
  }

  // pre-render
  let tabs = null;
  if((catalogue.activityPackages || []).length > 0) {
    tabs = (
      <div id="v-search-list-switch">
        <div className="inner">
          <div className={`item ${search.subcatalogue === "singles" ? "active" : ""}`} onClick={() => search.setSubcatalogue("singles")}>
            <div className="item-inner">
              Selber zusammenstellen
            </div>
          </div>
          <div className={`item ${search.subcatalogue === "packages" ? "active" : ""}`} onClick={() => search.setSubcatalogue("packages")}>
            <div className="item-inner">
              Erlebnis-Packages
            </div>
          </div>
        </div>
      </div>
    )
  }
  
  // render
  return (
    <div id="v-search-list" ref={refListTop}>
      {tabs}
      <div id="v-search-list-items">
        {items}
      </div>
      <div id="v-search-list-count">
        <div>{countText}</div>
        {resetButton}
      </div>
    </div>
  )
}

export default List